import {getConfigItem, setConfigItem} from '../config';
import {EMBEDDABLE_BASE_URL} from '../constants';

/**
 * Description: Setter for `baseUrl` for Embeddable environment
 * @param {string} url - value to be used as baseurl
 * @returns {void}
 */
export const setEmbeddableBaseUrl = url => setConfigItem(EMBEDDABLE_BASE_URL, url);
/**
 * Description: Getter for `baseUrl` , used by HttpEffect, GraphQLEffect for preparing request `url`
 * @returns {string}
 */
export const getEmbeddableBaseUrl = () => getConfigItem(EMBEDDABLE_BASE_URL) || '';
